module.exports = __webpack_public_path__ + "media/images/Vision-2119e2ce.png";